export const feature = {
  standardHR: 4,
  advancedHR: 5,
  standardTime: 6,
  advancedTime: 7,
  centralized: 8,
  benefitsManagement: 9,
  standardScheduling: 11,
  hiddenHr: 17,
  classicPortal: 20,
  twpManagement: 22,
  employeeActivation: 24,
  breaksAndMeals: 25,
  basicAccruals: 27,
  advancedAccruals: 28,
  hardwareClocks: 29,
  organizationChart: 30,
  yearEndDocuments: 31,
  employeeInvites: 32,
  intelligentClock: 39,
  conversionTool: 41,
};

export const hasFeatureInFeatures = (features, featureId) => {
  if (!features) {
    return false;
  }

  return features.some((feat) => feat.id === featureId);
};
